var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.001,
    viewBox: "0 0 20 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.008,10174.5H357.992a.492.492,0,0,1-.492-.492V10158.8a.492.492,0,0,1,.144-.348l3.8-3.8a.49.49,0,0,1,.348-.145h15.213a.492.492,0,0,1,.492.492v19.016A.492.492,0,0,1,377.008,10174.5Zm-18.525-.983h18.033v-18.033H362l-3.515,3.516Z",
    transform: "translate(-357.5 -10154.502)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.918 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.172,10162.043h-9.18a.492.492,0,0,1-.492-.492v-6.557a.492.492,0,1,1,.984,0v6.065h8.2v-6.065a.492.492,0,1,1,.984,0v6.557A.492.492,0,0,1,382.172,10162.043Z",
    transform: "translate(-372.5 -10154.502)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.541 2.295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.992,10163.8a.492.492,0,0,1-.492-.492v-1.311a.492.492,0,1,1,.984,0v1.311A.492.492,0,0,1,380.992,10163.8Z",
    transform: "translate(-380.5 -10161.502)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.934 11.803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.139,10198.7a.492.492,0,0,1-.492-.492v-6.721H370.484v6.721a.492.492,0,1,1-.984,0v-7.213a.492.492,0,0,1,.492-.492h11.148a.492.492,0,0,1,.492.492v7.213A.492.492,0,0,1,381.139,10198.7Z",
    transform: "translate(-369.5 -10190.502)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.c815cd3322c4618c4e6e90a6dea1b895.svg";
export { ForwardRef as ReactComponent };